/**
 * Shared behaviour for the back-office screens.
 */
import { ApiError } from "../api/http";

/**
 * Codes that mean "these credentials are no good", as opposed to "that
 * request didn't work".
 *
 * The distinction matters: dropping the stored credentials is the right
 * response to a rejected key, and the wrong response to the API restarting.
 * Clearing on any failure meant a single blip threw the reviewer back to the
 * sign-in form, over and over.
 */
const CREDENTIAL_FAILURES = new Set([
  "invalid_admin_key",
  "admin_key_disabled",
  "reviewer_auth_disabled",
  "insufficient_permission",
  "unauthorized",
  "missing_token",
  "invalid_token",
  "token_expired",
  "wrong_token_type",
  "unknown_user",
  "account_inactive",
]);

export function isCredentialFailure(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;
  if (CREDENTIAL_FAILURES.has(error.code)) return true;
  // A bare 401/403 with no code we recognise is still a rejection.
  return error.status === 401 || error.status === 403;
}
